import initialGeoPointPin from '../images/address-icons/initial-geo-point-pin.svg';

export const initialGeoPointPinRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    defaultSymbol: {
        type: 'picture-marker',
        url: initialGeoPointPin,
        width: '32px',
        height: '32px',
    },
    authoringInfo: undefined,
};
